import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "VLMAG tells the complete story of the culture.",
    body: "The central platform documents the full picture — the people, the movements and the moments defining what comes next across fashion, music, art, sports and business.",
  },
  {
    n: "02",
    title: "VLMAG MUSIC gives the culture its sound.",
    body: "From debut releases to sold-out sets, the music network amplifies the artists, DJs and producers driving the rhythm of a generation.",
  },
  {
    n: "03",
    title: "VLMAG STYLE gives the culture its visual identity.",
    body: "Fashion is language. STYLE captures how designers, models and creatives use it to communicate who they are and what they represent.",
  },
  {
    n: "04",
    title: "Together, they elevate the people shaping what comes next.",
    body: "One creative media network built to document, support and elevate the next generation — in vision, in sound, and in identity.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="px-5 md:px-10 py-20 md:py-32 bg-black">
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="mb-12 md:mb-20"
    >
      <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#E30613] mb-4">How The Networks Connect</p>
      <h2 className="font-display uppercase leading-[0.9] tracking-tight text-4xl sm:text-5xl md:text-7xl max-w-4xl">
        A Manifesto for<br />the Next Generation
      </h2>
    </motion.div>

    <div>
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.n}
          data-testid={`manifesto-${c.n}`}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 items-start border-t border-white/10 py-10 md:py-14 group"
        >
          <div className="md:col-span-3">
            <span className="font-display text-7xl md:text-8xl stroke-text group-hover:[color:#E30613] group-hover:[-webkit-text-stroke:0] transition-all duration-500">
              {c.n}
            </span>
          </div>
          <h3 className="md:col-span-5 font-display uppercase text-2xl md:text-4xl leading-[0.95] tracking-tight text-white">
            {c.title}
          </h3>
          <p className="md:col-span-4 text-neutral-400 leading-relaxed text-base md:text-lg">{c.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
